import React from 'react';
import headshot from '../../assets/headshot.JPG';

const Home = () => (
  <div id="home" style={{
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(160deg, #FAF7F2 0%, #F5EDE0 100%)',
    color: '#2C1F14', padding: '6rem 2rem 4rem', position: 'relative', overflow: 'hidden'
  }}>
    <div style={{ maxWidth: 1100, width: '100%', display: 'flex', alignItems: 'center', gap: '4rem', flexWrap: 'wrap', justifyContent: 'center' }}>
      <div style={{ flex: '1 1 360px', maxWidth: 560 }}>
        <p style={{ color: '#B5624A', fontSize: '1.1rem', marginBottom: '0.75rem', fontWeight: 600 }}>Hi there, I'm</p>
        <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 4rem)', fontWeight: 800, margin: '0 0 0.5rem', lineHeight: 1.1,
          background: 'linear-gradient(135deg, #2C1F14 0%, #B5624A 100%)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>
          Shreya Sharma
        </h1>
        <h2 style={{ fontSize: 'clamp(1.2rem, 3vw, 1.6rem)', fontWeight: 500, color: '#7A8C5E', margin: '0 0 1.5rem' }}>
          Full-Stack Developer & CS Student
        </h2>
        <p style={{ fontSize: '1.1rem', lineHeight: 1.8, color: '#6B5444', marginBottom: '2.5rem', maxWidth: 480 }}>
          I build interactive, accessible web experiences with a focus on clean code and
          creative problem solving. Based in Canada, passionate about React and beyond.
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <a href="#projects"
            onClick={e => { e.preventDefault(); document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' }); }}
            style={{ background: 'linear-gradient(135deg, #B5624A 0%, #C87B5E 100%)', color: '#fff', padding: '0.85rem 2rem', borderRadius: '2rem', textDecoration: 'none', fontWeight: 700, fontSize: '1rem', display: 'inline-block' }}>
            View Projects
          </a>
          <a href="#about"
            onClick={e => { e.preventDefault(); document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' }); }}
            style={{ background: 'transparent', color: '#B5624A', padding: '0.85rem 2rem', borderRadius: '2rem', textDecoration: 'none', fontWeight: 700, fontSize: '1rem', border: '2px solid #B5624A', display: 'inline-block' }}>
            About Me
          </a>
        </div>
      </div>
      <div style={{ flex: '0 0 auto' }}>
        <div style={{ width: 260, height: 260, borderRadius: '50%', border: '4px solid rgba(181, 98, 74, 0.35)',
          boxShadow: '0 0 60px rgba(181,98,74,0.12), 0 20px 60px rgba(44,31,20,0.12)', overflow: 'hidden', background: 'rgba(245,237,224,0.8)' }}>
          <img src={headshot} alt="Shreya Sharma" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
      </div>
    </div>
  </div>
);

export default Home;
